/**
 * Web Style Import
 *
 */

import './style/dnb-copy-on-click.scss'
